import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Routes } from '@packages/enums';
import { useAppDispatch, useAppSelector } from '@ui/app/store';
import { Icon } from '@ui/assets/icons/IconWrapper';
import { selectUserEmail, selectUserName } from '@ui/hooks';
import { Avatar, Dropdown } from 'antd';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import Styles from '../Styles.module.scss';
import { clearAllTabs } from '@ui/features/Chat/slices/tabsSlice';
import { STORAGE_KEYS } from '@ui/features/Chat/constants';
import { sessionStorageManager } from '@ui/features/Chat/utils/sessionStorageCleanup';
import { api } from '@ui/app/api';

interface SidebarProfileProps {
    collapsed: boolean;
}

const SidebarProfile: React.FC<SidebarProfileProps> = ({ collapsed }) => {
    const name = useAppSelector(selectUserName);
    const email = useAppSelector(selectUserEmail);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isProfileOpen, setIsProfileOpen] = useState(false);

    const handleLogout = async () => {
        try {
            sessionStorageManager.clearAll();
            localStorage.removeItem(STORAGE_KEYS.TABS);
            dispatch(clearAllTabs());
            dispatch(api.util.resetApiState());
            await fetch('/api/auth/logout', { credentials: 'include', method: 'POST' });
            window.location.href = '/';
        } catch {
            window.location.href = '/';
        }
    };

    const profileMenu = {
        items: [
            { key: 'profile', label: 'Profile', icon: <UserOutlined /> },
            {
                key: 'settings',
                label: 'Settings',
                icon: <SettingOutlined />,
                onClick: () => navigate(Routes.SETTINGS),
            },
            {
                key: 'logout',
                label: 'Logout',
                icon: <LogoutOutlined />,
                onClick: handleLogout,
            },
        ],
    };

    return (
        <Dropdown
            menu={profileMenu}
            placement="topLeft"
            trigger={['click']}
            onOpenChange={setIsProfileOpen}
            overlayStyle={{ width: '200px' }}
            className={Styles.profile}
        >
            {!collapsed ? (
                <div>
                    <Avatar
                        size={34}
                        src={`https://api.dicebear.com/9.x/initials/svg?seed=${name}`}
                    />
                    <div className="flex-1 overflow-hidden">
                        <div className="truncate text-sm font-medium">{name}</div>
                        <div
                            className="truncate"
                            style={{ fontSize: 10 }}
                        >
                            {email}
                        </div>
                    </div>
                    <Icon
                        name="CheveronIcon"
                        size={12}
                        className={classNames(
                            'text-xs text-white transition-transform duration-200',
                            isProfileOpen ? 'rotate-180' : ''
                        )}
                    />
                </div>
            ) : (
                <div className="mx-3 !border-none">
                    <Avatar
                        size={34}
                        src={`https://api.dicebear.com/9.x/initials/svg?seed=${name}`}
                    />
                </div>
            )}
        </Dropdown>
    );
};

export default React.memo(SidebarProfile);
